export const config = {
  tribes: ['DXI', 'FSS', 'CAI', 'KRM', 'EDC'],
  solutions: {
    DXI: {
      'API ECOSYSTEM': 'API',
      DX: 'DX',
      PFS: 'PFS',
    },
    FSS: {
      'Dynamic Maintenance Planning (DMP)': 'DMP',
      'Service Tools': 'ST',
    },
    CAI: {
      'AWS IoT Core': 'IoT',
      'SAP Platform / Supportive': 'SAP',
    },
    KRM: {
      'Kone Remote Monitoring': 'KRM',
    },
    EDC: {
      EDC: 'EDC',
    },
  },
};

export default config;
